import axios, { AxiosResponse } from "axios";
import { URL } from "../endpoints/index";

// Define types for the login function parameters and response
interface LoginParams {
  token: string;
}

interface LoginResponse {
  msg: string;
  user: any; // You can replace `any` with the actual user type if known
}

/**
 * @method POST
 * @route
 * @body {Object} user
 * @returns {Promise<LoginResponse>} returns a Promise either an error or the response object msg & user
 */
export const jwtTokenLogin = async ({
  token,
}: LoginParams): Promise<LoginResponse> => {
  try {
    const response: AxiosResponse<LoginResponse> = await axios.post(
      `${URL.USER_PROFILES.BASE}${URL.USER_PROFILES.V1_USER_ZIFT_LOGIN}`,
      { token },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
